export default __webpack_public_path__ + "static/media/logo_Qibo.dabc30b9.png";